import Account from "../components/project/Account";

function UserPage(props) {
  return <Account></Account>;
}

export default UserPage;
